export default "__VITE_ASSET__CIPbQSE9__"